import script from "./SendView.vue?vue&type=script&setup=true&lang=js"
export * from "./SendView.vue?vue&type=script&setup=true&lang=js"

import "./SendView.vue?vue&type=style&index=0&id=5e83d796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e83d796"]])

export default __exports__